<template>
  <!--三个导航页-->
    <div>
        <ul class="dtai-news-content">
          <li>
            <router-link to="/home_en/0/detail/331">
              【Invitation Letter】1<sup>st</sup> Beijing Tiantan International Forum of Neurosurgery(BIFNS)
            </router-link>
          </li>
          <li>
            <router-link to="/home_en/1/detail/329">
              【Invitation Letter】 Meeting of International Meningioma society
            </router-link>
          </li>
          <li>
            <router-link to="/home_en/2/detail/330">
              【Invitation Letter】 Meningioma Society Announcement</span>
            </router-link>
          </li>
        </ul>
    </div>
</template>
<script>
    export default{
        data(){
            return {}
        },
        props: {},
        methods: {},
        computed: {},
        mounted(){
        }
    }
</script>
<style scoped>
  .dtai-news-box {
    width: 897px;
    margin-right: 5px;
    float: left;
  }
  .dtai-news-content{
    margin-top:20px;
  }
  .dtai-news-content li{
    padding-bottom: 10px;
  }
  .dtai-news-content a{
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// link_c.vue?6d0bc6a0